<af-main-container [title]="'i18n_lib_breadcrumb#Edit' | translate"
                   spinnerIds="initial"
                   [customLastBreadcrumb]="trendId && 'i18n_lib_breadcrumb#TrendId' | translate :{trendId: trendId}"
                   [navigateBackListener]="navigateBack"
                   [specialFilter]="trendId && filterTrendIdPath">
    @if (trendId || hasReachedLastStep) {
        <div CustomTitle
             fxFlex
             fxLayout="row" fxLayoutAlign="end center" class="w-100">
            <ui-kit-button [label]="'i18n_af_buttonCancel' | translate"
                           type="secondary"
                           [disabled]="Spinner.isShown('editTrend')"
                           (clickListener)="openCancellationWarningDialog()"/>
            <ui-kit-button [label]="'i18n_af_buttonSave' | translate"
                           class="ml-16"
                           [spinnerId]="'editTrend'"
                           [disabled]='isButtonDisabled || (!trendId && form.invalid)'
                           (clickListener)="sendRequest()"/>
        </div>
    }
    <div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start" fxFlex>
        <ui-kit-stepper #stepper class="mt-32"
                        [hasNavigation]="true"
                        [currentStep]="currentStep"
                        [steps]="steps"
                        [isStepCompleted]="isStepCompleted"
                        (stepIndexChangeListener)="onStepChange($event)"/>
        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100 overflow-y-hidden">
            @for (step of steps; track step) {
                @if (step === 'trend' && step === currentStep) {
                    <af-trend-information-step
                        [form]="form.controls.trendInformationForm"
                        [trend]="trend"
                        class="w-100 mt-24 h-fit-content overflow-y-scroll"
                        (typeChangeListener)="changeStepper($event)"
                        (nextStep)="stepper.nextStep()"
                        fxFlex
                        (cancel)="openCancellationWarningDialog()"/>
                }
                @if (step === 'incidents' && step === currentStep) {
                    <af-trend-incidents-step
                        [form]="form.controls.trendIncidentsForm"
                        [trendIncidents]="trendIncidents"
                        class="w-100 mt-24 h-fit-content overflow-y-scroll"
                        fxFlex
                        (nextStep)="stepper.nextStep()"
                        (previousStep)="stepper.previousStep()"
                        (cancel)="openCancellationWarningDialog()"/>
                }
                @if (step === 'statistics' && step === currentStep && lastSteps.includes(step)) {
                    <af-trend-statistics-step
                        [form]="form.controls.trendStatisticsForm"
                        [trendStatistics]="trendStatistics"
                        (previousStep)="stepper.previousStep()"
                        class="w-100 mt-24 h-fit-content overflow-y-scroll"
                        fxFlex
                        (cancel)="openCancellationWarningDialog()"/>
                }
            }
        </div>
    </div>
</af-main-container>
